export const GET_FILES_SUCCESS = "GET_FILES_SUCCESS";
export const ADD_REMOVE_FILES = "ADD_REMOVE_FILES";
export const GET_FILES_LIST = "GET_FILES_LIST";
export const GET_CS_USER = "GET_CS_USER";
export const GET_CS_USER_SUCCESS = "GET_CS_USER_SUCCESS";
export const ADD_SHARE_FILE = "ADD_SHARE_FILE";
export const GET_SHARED_FILES = "GET_SHARED_FILES";
export const GET_SHARED_FILES_SUCCESS = "GET_SHARED_FILES_SUCCESS";
export const REMOVE_SHARE_FILE = "REMOVE_SHARE_FILE";
